import styled from 'styled-components';

import {
  xdlPaletteGrayPlain02,
  xdlPaletteGrayPlain04,
  xdlPaletteGrayPlain07,
  xdlPaletteGrayPlain10,
} from '@xing-com/tokens';

export const Wrapper = styled.div`
  align-items: center;
  background-color: ${xdlPaletteGrayPlain02};
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  font-family: FiraSans-Regular;
  height: 100%;
  justify-content: center;
  min-width: 320px;
  padding: 56px;
  width: 100%;

  @media (max-width: 1113px) {
    .wrapper {
      flex-wrap: nowrap;
      width: 100%;
    }
  }
`;

export const Image = styled.img`
  width: 72px;
`;

export const TitleSpinnerWrapper = styled.span`
  display: flex;
  justify-content: center;
  position: relative;
`;

export const Title = styled.p`
  border-bottom: 1px solid ${xdlPaletteGrayPlain04};
  color: ${xdlPaletteGrayPlain10};
  font-size: 18px;
  padding-bottom: 24px;
  text-align: center;

  @media (max-width: 1113px) {
    .title {
      border-bottom: none;
    }
  }
`;

export const Description = styled.p`
  color: ${xdlPaletteGrayPlain07};
  font-size: 12px;
  line-height: 16px;
  margin-top: 8px;
  max-width: 500px;
  text-align: center;

  @media (max-width: 1113px) {
    .description {
      display: none;
    }
  }
`;

export const SpinnerWrapper = styled.span`
  background-color: ${xdlPaletteGrayPlain02};
  bottom: 13px;
  color: ${xdlPaletteGrayPlain07};
  position: absolute;
  text-align: center;
  width: 60px;

  & > div {
    justify-content: center;
  }

  & > div > div {
    background-color: ${xdlPaletteGrayPlain07};
  }
`;
